import { z } from 'zod';
import { ErrorTypes } from '../../../utils/constants.js';
import { baseStructureSchema, baseSettingsSchema } from './base.structure.js';
import { blockSchema } from './block.js';

var QuestionDisplayVariant = /* @__PURE__ */ ((QuestionDisplayVariant2) => {
  QuestionDisplayVariant2["WORD_CLOUD"] = "word_cloud";
  return QuestionDisplayVariant2;
})(QuestionDisplayVariant || {});
const wordcloudStructureSchema = baseStructureSchema.extend({
  query: blockSchema.refine((query) => {
    const hasMedia = query.media?.length > 0;
    if (hasMedia) {
      return true;
    }
    if (!query.text) {
      return false;
    }
    const regex = /<[^>]+>/g;
    const cleanedText = query.text.replace(regex, "").trim();
    const hasLatex = query.text.includes("<katex");
    return cleanedText.length > 0 || hasLatex;
  }, {
    message: ErrorTypes.EMPTY_QUERY
  }),
  marks: z.object({
    correct: z.number().min(0).max(20)
  }).optional(),
  settings: baseSettingsSchema.extend({
    questionDisplayVariant: z.nativeEnum(QuestionDisplayVariant).optional(),
    canSubmitCustomResponse: z.boolean().optional()
  })
});

export { QuestionDisplayVariant, wordcloudStructureSchema };
